import BaseModel from "../BaseModel";
import SampleTest from './SampleTest';

export default class ReportedSample extends BaseModel {
	static entity = 'reportedSamples';
	static primaryKey = "uuid";
	static fields(){
		return {
			uuid: this.attr(null),
			sample_id: this.attr(null),
			customer_id: this.attr(null),
			customer_name: this.attr(null),
			sample_name: this.attr(null),
			sample_cert_type: this.attr(null),
			sample_cert_type_category: this.attr(null),
			address_1: this.attr(null),
			address_2: this.attr(null),
			ubi: this.attr(null),
			canna_license: this.attr(null),
			manifest_id: this.attr(null),
			qa: this.attr(null),
			lot: this.attr(null),
			unit: this.attr(null),
			weight: this.attr(null),
			serving_weight: this.attr(null),
			date_of_harvest: this.attr(null),
			date_of_receipt: this.attr(null),
			date_of_testing: this.attr(null),
			amended: this.attr(null),
			is_rnd: this.attr(null),
			billed: this.attr(null),
			hidden: this.attr(null),
			scientific_director: this.attr(null),
			laboratory_director: this.attr(null),
			sample_tests: this.hasMany(SampleTest, 'sample_uuid'),
		}
	}
	
	static route(){
		return process.env.VUE_APP_REPORTED_API + '/samples';
	}
	
	static apiConfig = {
		...super.apiConfig,
		headers: {
			"Accept": "application/json",
			"Authorization": process.env.VUE_APP_REPORTED_API_KEY,
			"VueRoute": window.location.href,
		}
	}
}
